// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evenement__container {
  padding: 3em 0;
}

.evenement__description {
  max-width: 60rem;
  margin: 0 auto;
}

.evenement__description h1 {
  color: var(--clr-primary);
  text-align: center;
}

.evenement h2 {
  font-size: 1.5rem;
  color: var(--clr-gray800);
  white-space: nowrap;
  text-align: center;
}

@media (min-width: 375px) {
  .evenement h2 {
    font-size: 1.5rem;
  }
}
.evenement__description p {
  margin: 3rem 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.65;
  text-align: center;
}

.evenement__imgContainer {
  display: flex;
  position: relative;
  max-width: 19rem;
}

.evenement__imgContainer::before {
  content: "";
  /* background: ; */
  position: absolute;
  /* background: black; */
  height: 100%;
  width: 50%;
  z-index: 4;
  right: 0;
  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.evenement__imageSection {
  position: relative;
  max-width: 37rem;
  /* transform: scale(0.5); */
}

.evenement__imgContainerArrow {
  position: absolute;
  z-index: 4;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.evenement__imgContainerArrow svg {
  width: 5rem;
  cursor: pointer;
}

.evenement__img {
  /* flex: 1 1 50%; */
  position: relative;
  object-fit: cover;
  width: 15rem;
  height: 15rem;
  border-radius: 1em;
  flex-shrink: 0;
}

.evenement__img:nth-of-type(1) {
  z-index: 4;
}

.evenement__img:nth-of-type(2) {
  left: -65%;
  z-index: 3;
  opacity: 0.8;
  transform: scale(0.9);
}
.evenement__img:nth-of-type(3) {
  left: calc(-65% - 65%);
  z-index: 2;
  opacity: 0.7;
  transform: scale(0.8);
}
.evenement__img:nth-of-type(4) {
  left: calc(-65% - 65% - 65%);
  z-index: 1;
  opacity: 0.6;
  transform: scale(0.7);
}

.evenement__img:nth-of-type(n + 5) {
  display: none;
}

.evenement__imageSectionContainer {
  margin: 3rem auto;
  width: -moz-fit-content;
  width: fit-content;
}

.evenement__imageSectionContainer h2 {
  font-size: 1.5rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--clr-primary);
  text-align: center;
}

/* @media (min-width: 425px) {
  .evenement__imageSection {
    transform: scale(0.65);
  }
} */
/* @media (min-width: 475px) {
  .evenement__imageSection {
    transform: scale(0.7);
  }
}
@media (min-width: 500px) {
  .evenement__imageSection {
    transform: scale(0.75);
  }
}
@media (min-width: 600px) {
  .evenement__imageSection {
    transform: scale(0.85);
  }
} */

.evenment__btn {
  border-radius: 0.75em;
  margin: 7rem auto;
  margin-bottom: 4rem;
}

@media (min-width: 768px) {
  .evenement__description h1 {
    font-size: 2.5rem;
  }

  /* .evenement__imageSection {
    transform: scale(1);
  } */
}

/* @media (min-width: 992px) {
  .evenement__imageSection {
    transform: scale(0.8);
  }
} */

@media (min-width: 1200px) {
  .evenement__imageSection {
    transform: unset;
  }

  .evenement__img {
    width: 28rem;
    height: 28rem;
  }

  .evenement__imageSectionContainer h2 {
    font-size: 2rem;
  }

  .evenment__imageSectionRow {
    display: flex;
  }

  .evenement__imgContainer {
    max-width: unset;
  }

  .evenement__imgContainerArrow {
    right: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Evenement/Evenement.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,QAAQ;EACR,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;GAIG;AACH;;;;;;;;;;;;;;GAcG;;AAEH;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;KAEG;AACL;;AAEA;;;;GAIG;;AAEH;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".evenement__container {\n  padding: 3em 0;\n}\n\n.evenement__description {\n  max-width: 60rem;\n  margin: 0 auto;\n}\n\n.evenement__description h1 {\n  color: var(--clr-primary);\n  text-align: center;\n}\n\n.evenement h2 {\n  font-size: 1.5rem;\n  color: var(--clr-gray800);\n  white-space: nowrap;\n  text-align: center;\n}\n\n@media (min-width: 375px) {\n  .evenement h2 {\n    font-size: 1.5rem;\n  }\n}\n.evenement__description p {\n  margin: 3rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.65;\n  text-align: center;\n}\n\n.evenement__imgContainer {\n  display: flex;\n  position: relative;\n  max-width: 19rem;\n}\n\n.evenement__imgContainer::before {\n  content: \"\";\n  /* background: ; */\n  position: absolute;\n  /* background: black; */\n  height: 100%;\n  width: 50%;\n  z-index: 4;\n  right: 0;\n  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.evenement__imageSection {\n  position: relative;\n  max-width: 37rem;\n  /* transform: scale(0.5); */\n}\n\n.evenement__imgContainerArrow {\n  position: absolute;\n  z-index: 4;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.evenement__imgContainerArrow svg {\n  width: 5rem;\n  cursor: pointer;\n}\n\n.evenement__img {\n  /* flex: 1 1 50%; */\n  position: relative;\n  object-fit: cover;\n  width: 15rem;\n  height: 15rem;\n  border-radius: 1em;\n  flex-shrink: 0;\n}\n\n.evenement__img:nth-of-type(1) {\n  z-index: 4;\n}\n\n.evenement__img:nth-of-type(2) {\n  left: -65%;\n  z-index: 3;\n  opacity: 0.8;\n  transform: scale(0.9);\n}\n.evenement__img:nth-of-type(3) {\n  left: calc(-65% - 65%);\n  z-index: 2;\n  opacity: 0.7;\n  transform: scale(0.8);\n}\n.evenement__img:nth-of-type(4) {\n  left: calc(-65% - 65% - 65%);\n  z-index: 1;\n  opacity: 0.6;\n  transform: scale(0.7);\n}\n\n.evenement__img:nth-of-type(n + 5) {\n  display: none;\n}\n\n.evenement__imageSectionContainer {\n  margin: 3rem auto;\n  width: fit-content;\n}\n\n.evenement__imageSectionContainer h2 {\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  margin-bottom: 1rem;\n  color: var(--clr-primary);\n  text-align: center;\n}\n\n/* @media (min-width: 425px) {\n  .evenement__imageSection {\n    transform: scale(0.65);\n  }\n} */\n/* @media (min-width: 475px) {\n  .evenement__imageSection {\n    transform: scale(0.7);\n  }\n}\n@media (min-width: 500px) {\n  .evenement__imageSection {\n    transform: scale(0.75);\n  }\n}\n@media (min-width: 600px) {\n  .evenement__imageSection {\n    transform: scale(0.85);\n  }\n} */\n\n.evenment__btn {\n  border-radius: 0.75em;\n  margin: 7rem auto;\n  margin-bottom: 4rem;\n}\n\n@media (min-width: 768px) {\n  .evenement__description h1 {\n    font-size: 2.5rem;\n  }\n\n  /* .evenement__imageSection {\n    transform: scale(1);\n  } */\n}\n\n/* @media (min-width: 992px) {\n  .evenement__imageSection {\n    transform: scale(0.8);\n  }\n} */\n\n@media (min-width: 1200px) {\n  .evenement__imageSection {\n    transform: unset;\n  }\n\n  .evenement__img {\n    width: 28rem;\n    height: 28rem;\n  }\n\n  .evenement__imageSectionContainer h2 {\n    font-size: 2rem;\n  }\n\n  .evenment__imageSectionRow {\n    display: flex;\n  }\n\n  .evenement__imgContainer {\n    max-width: unset;\n  }\n\n  .evenement__imgContainerArrow {\n    right: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
